"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var minio_1 = require("minio");
var http_1 = require("@angular/common/http");
var streamToPromise = require("stream-to-promise");
var MinioStaticResourceUrlProvider = /** @class */ (function () {
    function MinioStaticResourceUrlProvider(http) {
        this.http = http;
        this.staticResourcesUrl = 'properties/static-resources-url';
    }
    /**
     * Loads object names from the specified folder from minio storage static resource bucket recursively
     * If folder name is not specified loads all object names of the bucket
     * @param folderName
     */
    MinioStaticResourceUrlProvider.prototype.getResources = function (folderName) {
        var _this = this;
        if (folderName === void 0) { folderName = ''; }
        return this.getStaticResourcesUrl()
            .then(function (urlData) {
            return Promise.all([Promise.resolve(urlData),
                streamToPromise(_this.client.listObjects(urlData.bucket, urlData.application + "/" + folderName, true))
            ]);
        })
            .then(function (_a) {
            var urlData = _a[0], data = _a[1];
            // @ts-ignore
            return data.slice().map(function (item) { return urlData.host + "/" + urlData.bucket + "/" + item.name; });
        });
    };
    /**
     * Loads static resource url and creates minio client for loading resources names
     */
    MinioStaticResourceUrlProvider.prototype.getStaticResourcesUrl = function () {
        var _this = this;
        if (!this.staticResourcesUrlPromise) {
            this.staticResourcesUrlPromise = this.http.get(this.staticResourcesUrl).map(function (data) {
                var host = data.host || '';
                var hostWithoutHttp = host.includes('://') ? host.split('://')[1] : host;
                var separatedHost = hostWithoutHttp.split(':');
                _this.client = new minio_1.Client({
                    endPoint: separatedHost[0],
                    useSSL: true,
                    accessKey: '',
                    secretKey: ''
                });
                return data;
            }).toPromise();
        }
        return this.staticResourcesUrlPromise;
    };
    MinioStaticResourceUrlProvider = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], MinioStaticResourceUrlProvider);
    return MinioStaticResourceUrlProvider;
}());
exports.MinioStaticResourceUrlProvider = MinioStaticResourceUrlProvider;
//# sourceMappingURL=minio-static-resource-url-provider.js.map